import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Padding from "../../components/common/Padding";
import colors from "../../styles/colors";

const style = {
  pageLetter: {
    pageBreakInside: "avoid",
    padding: "5mm",
    display: "flex",
    flexFlow: "column",
    alignItems: "left",
    alignSelf: "center",
  },
  mainHeader: {
    fontSize: 32,
    fontWeight: "bold",
    color: "#696969",
    marginTop: 10,
    marginBottom: 0,
  },
  subHeader: {
    fontSize: 26,
    textAlign: "center",
    color: colors.primary,
  },
  body: {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "16px",
    color: "#696969",
    textAlign: "left",
    margin: 20,
  },
  instructionDetail: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
    flexWrap: "wrap",
  },
  labelContainer: {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "16px",
    color: "#696969",
    maringBottom: 5,
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
  },
  label: {
    marginRight: 5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "16px",
    color: colors.steelBlue,
  },
  borderBottom: {
    borderBottom: "solid",
    borderBottomWidth: 1,
    color: colors.skyBlue,
    margin: 0,
    padding: 0,
  },
  row: {
    position: "relative",
    margin: 5,
  },
  categoryImage: {
    maxHeight: 250,
    maxWidth: 250,
  },
  imageRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
};
export default (props) => {
  const [wistiaThumb, setWistiaThumb] = useState(null);

  useEffect(() => {
    if (props.wistiaVideo && props.wistiaVideo.id) {
      const url =
        "https://fast.wistia.net/oembed?url=https://home.wistia.com/medias/" +
        props.wistiaVideo.id;
      fetch(url)
        .then((response) => response.json())
        .then((data) => setWistiaThumb(data.thumbnail_url))
        .catch((err) => console.log(err));
    }
  }, [props.wistiaVideo]);

  return (
    <div id={props.id} style={{ ...style.pageLetter }}>
      <h4 style={style.mainHeader}>{props.category.categoryName}</h4>
      <div style={style.body}>{props.category.categoryDesc}</div>
      <div style={style.imageRow}>
        {props.category.videoPreviewUrl && (
          <div style={style.row}>
            <img
              alt="Instruction"
              src={props.category.videoPreviewUrl}
              style={style.categoryImage}
            />
          </div>
        )}
        {props.category.imageUrl && (
          <div style={style.row}>
            <img
              alt="Instruction"
              src={props.category.imageUrl}
              style={style.categoryImage}
            />
          </div>
        )}
        {props.category.physioImage && (
          <div style={style.row}>
            <img
              alt="Instruction"
              src={props.category.physioImage}
              style={style.categoryImage}
            />
          </div>
        )}{" "}
        {props.category.youtubeVideo && props.category.youtubeVideo.id && (
          <div style={style.row}>
            <img
              alt="Instruction"
              src={
                "https://img.youtube.com/vi/" +
                props.category.youtubeVideo.id +
                "/0.jpg"
              }
              style={style.categoryImage}
            />
          </div>
        )}
        {wistiaThumb && (
          <div style={style.row}>
            <img
              alt="Instruction"
              src={wistiaThumb}
              style={style.categoryImage}
            />
          </div>
        )}
      </div>
      {(props.category.defaultSets ||
        props.category.defaultReps ||
        props.category.defaultDuration ||
        props.category.defaultIntensity ||
        props.category.defaultFrequency ||
        props.category.defaultWeight ||
        props.category.defaultHold ||
        props.category.defaultRest ||
        props.category.defaultTempo) && (
        <h4 style={style.borderBottom}>Defaults</h4>
      )}
      <div style={style.instructionDetail}>
        {props.category.defaultReps && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Reps:</label>
              {props.category.defaultReps}
            </p>
          </div>
        )}
        {props.category.defaultSets && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Sets:</label>
              {props.category.defaultSets}
            </p>
          </div>
        )}
        {props.category.defaultDuration && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Duration:</label>
              {props.category.defaultDuration}
            </p>
          </div>
        )}
        {props.category.defaultIntensity && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Intensity:</label>
              {props.category.defaultIntensity}
            </p>
          </div>
        )}
        {props.category.defaultFrequency && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Frequency:</label>
              {props.category.defaultFrequency}
            </p>
          </div>
        )}
        {props.category.defaultFrequency && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Frequency:</label>
              {props.category.defaultFrequency}
            </p>
          </div>
        )}
        {props.category.defaultWeight && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Weight:</label>
              {props.category.defaultWeight}
            </p>
          </div>
        )}
        {props.category.defaultHold && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Hold:</label>
              {props.category.defaultHold}
            </p>
          </div>
        )}
        {props.category.defaultRest && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Rest:</label>
              {props.category.defaultRest}
            </p>
          </div>
        )}
        {props.category.defaultTempo && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Tempo:</label>
              {props.category.defaultTempo}
            </p>
          </div>
        )}
      </div>
      <Padding height={15} />
      {(props.category.numSets ||
        props.category.numRepetitions ||
        props.category.duration ||
        props.category.intensity ||
        props.category.frequency ||
        props.category.weight ||
        props.category.hold ||
        props.category.rest ||
        props.category.tempo) && <h4 style={style.borderBottom}> </h4>}
      <div style={style.instructionDetail}>
        {props.category.numRepetitions && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Reps:</label>
              {props.category.numRepetitions}
            </p>
          </div>
        )}
        {props.category.numSets && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Sets:</label>
              {props.category.numSets}
            </p>
          </div>
        )}
        {props.category.duration && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Duration:</label>
              {props.category.duration}
            </p>
          </div>
        )}
        {props.category.intensity && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Intensity:</label>
              {props.category.intensity}
            </p>
          </div>
        )}
        {props.category.frequency && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Frequency:</label>
              {props.category.frequency}
            </p>
          </div>
        )}{" "}
        {props.category.weight && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Weight:</label>
              {props.category.weight}
            </p>
          </div>
        )}
        {props.category.hold && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Hold:</label>
              {props.category.hold}
            </p>
          </div>
        )}
        {props.category.rest && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Rest:</label>
              {props.category.rest}
            </p>
          </div>
        )}
        {props.category.tempo && (
          <div style={style.labelContainer}>
            <p>
              <label style={style.label}>Tempo:</label>
              {props.category.tempo}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/layout/playbook/LibraryInstructionPrint.js